/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {PipesModule} from '../../../../shared/pipes/pipes.module';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';
import {SupplyingPackingPlantModalComponent} from './supplying-packing-plant-modal.component';

@NgModule({
    declarations: [SupplyingPackingPlantModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        InputModule,
        ActiveInputModule,
        PipesModule,
        TooltipModule
    ]
})
export class SupplyingPackingPlantModalModule {
}
